import { ComponentUITypes, DefaultModelProperty, LabelValue } from '../standard'
import Series from './series-model'
import seriesProperties from './series-properties'
import { SeriesProperties } from './series-property-definitions'

import { Rating } from '../enumerations'
export async function OnEvents(
  eventType: string,
  form: Series,
  property: SeriesProperties,
): Promise<Series> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(page: any, property: SeriesProperties): boolean {
  switch (property) {
    case SeriesProperties.Description:
      return (() => {
        function _defaultView(): any {
          return !!page
        }
        return _defaultView()
      })()
      break
    case SeriesProperties.Name:
      return (() => {
        function _defaultView(): any {
          return !!page
        }
        return _defaultView()
      })()
      break
    default:
      return false
  }
}

export function IsVisible(page: any, property: SeriesProperties): boolean {
  switch (property) {
    case SeriesProperties.Description:
      return (() => {
        function _defaultView(): any {
          return !page
        }
        return _defaultView()
      })()
      break
    case SeriesProperties.Name:
      return (() => {
        function _defaultView(): any {
          return !page
        }
        return _defaultView()
      })()
      break
    case SeriesProperties.TitleMediaUrl:
      return (
        (() => {
          function _viewMediaUrl(): any {
            return page === 'view-media-url' || page === undefined
          }
          return _viewMediaUrl()
        })() === true
      )
      break
    case SeriesProperties.TitleMediaImageUrl:
      return (
        (() => {
          function _viewMediaImageUrl(): any {
            return page === 'view-media-image-url' || page === undefined
          }
          return _viewMediaImageUrl()
        })() === true
      )
      break
    case SeriesProperties.ReleaseDate:
      return (() => {
        function _defaultView(): any {
          return !page
        }
        return _defaultView()
      })()
      break
    case 'owner':
      return false
    case 'id':
      return false
    case 'created':
      return false
    case 'updated':
      return false
    case 'deleted':
      return false
    case 'version':
      return false
    case SeriesProperties.Seasons:
      return false
    case SeriesProperties.Casting:
      return false
    case 'mediaStatus':
      return false
    case 'titleTransparentUrl':
      return (() => {
        function _viewTitleImageUrl(): any {
          return page === 'view-title-image-url' || page === undefined
        }
        return _viewTitleImageUrl()
      })()
      break
    case 'genre':
      return false
    case 'tags':
      return false
    case 'titleMediaImageLocation':
      return false
    case 'titleMediaLocation':
      return false
    case 'titleTransparentLocation':
      return false
    case 'hasProcessed':
      return false
    default:
      return true
  }
}
async function change(
  property: SeriesProperties,
  value: Series,
): Promise<Series> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<SeriesProperties>[] {
  return seriesProperties as DefaultModelProperty<SeriesProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<SeriesProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      case SeriesProperties.Description:
        return 2
      case SeriesProperties.Name:
        return 1
      case SeriesProperties.ReleaseDate:
        return 4
      case 'genre':
        return 8
      case 'tags':
        return 7
      case 'rating':
        return 3
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<SeriesProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<SeriesProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(property: SeriesProperties): LabelValue<any>[] {
  switch (property) {
    case 'rating':
      return Object.entries(Rating).map((v) => {
        return {
          label: v[0],
          value: v[1],
        }
      })
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: SeriesProperties): boolean {
  switch (property) {
    case 'owner':
      return false
    case 'id':
      return false
    case 'created':
      return false
    case 'updated':
      return false
    case 'deleted':
      return false
    case 'version':
      return false
    case SeriesProperties.Seasons:
      return false
    case SeriesProperties.Casting:
      return false
    case 'mediaStatus':
      return false
    case 'titleTransparentUrl':
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<SeriesProperties>[],
): DefaultModelProperty<SeriesProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<SeriesProperties>) => {
      switch (modelProperty.name) {
        case SeriesProperties.Description:
          modelProperty.type = ComponentUITypes.TEXTAREA
          break
        case SeriesProperties.Rating:
          modelProperty.type = ComponentUITypes.DROPDOWN
          break
        default:
          switch (modelProperty.name) {
            case SeriesProperties.TitleMediaUrl:
              modelProperty.type = 'view-media-video'

              break
            case SeriesProperties.TitleMediaImageUrl:
              modelProperty.type = 'view-media-thumbnail'

              break
            case SeriesProperties.TitleTransparentUrl:
              modelProperty.type = 'view-media-thumbnail'

              break
            default:
              break
          }

          break
      }
      return modelProperty
    },
  )
}
